import { render, staticRenderFns } from "./SkeletonScreen.vue?vue&type=template&id=48e7b657&scoped=true&"
import script from "./SkeletonScreen.vue?vue&type=script&lang=js&"
export * from "./SkeletonScreen.vue?vue&type=script&lang=js&"
import style0 from "./SkeletonScreen.vue?vue&type=style&index=0&id=48e7b657&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e7b657",
  null
  
)

export default component.exports